import { getValue } from '@service/firebase';

import Service from './serviceFactory';

const getBaseURL = () => {
  const isKrakendEnabled = !!getValue(
    'VITE_FEATURE_FLAG_IS_AGENCY_MARKETING_KRAKEND_ENABLE',
  )?.asBoolean();

  if (isKrakendEnabled) {
    return import.meta.env.VITE_API_KRAKEND_BASEURL ?? 'http://localhost:3000';
  }

  return import.meta.env.VITE_API_BASEURL ?? 'http://localhost:3000';
};

// Pass the function itself, not the result - it will be evaluated on each request
const KrakendServiceAPI = new Service(getBaseURL);

export { KrakendServiceAPI as default };
